export default __webpack_public_path__ + "media/78f3fa209f52c271e42eb73cedc4886b22457a370e7f07aca2a009cb30f18e29.svg";